// extracted by mini-css-extract-plugin
module.exports = {"container":"TabItem_container__YVJaw","activeTab":"TabItem_activeTab__GlbXA","activeTab1":"TabItem_activeTab1__jfGMq","tooltip":"TabItem_tooltip__VI_qm"};